import { render } from "./UnitDetails.vue?vue&type=template&id=68359ea8&scoped=true"
import script from "./UnitDetails.vue?vue&type=script&lang=js"
export * from "./UnitDetails.vue?vue&type=script&lang=js"

import "./UnitDetails.vue?vue&type=style&index=0&id=68359ea8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-68359ea8"

export default script